module.exports = "/_next/static/images/123355e76b3bac6ac6df106a014f7872-slide-cajita-turbo.png.webp";